import { Alert, Button, Dialog, DialogActions, DialogContent, DialogTitle, Snackbar } from '@mui/material';
import SubmitButton from 'common/SingleClickButton';
import { useEffect, useState } from 'react';
import { FormProvider, useForm } from 'react-hook-form';
import { store } from 'store/store';
import * as Action from '../action/action';
import TenantCreationDetail from './tenantCreationDetails';
import { getTenantCreationValues } from './tenantCreationDefaults';
import { buildPayload } from './tenantCreationPayload';

const TenantCreationDialog = (props) => {
  const { onClose, open, target } = props;
  const methods = useForm({ defaultValues: getTenantCreationValues(target), mode: 'onBlur' });
  const { reset, formState } = methods;
  const [errorMessage, setErrorMessage] = useState('');

  const handleClose = (data) => {
    onClose(data);
  };

  const onSubmit = async (data) => {
    const payload = buildPayload(data);
    try {
      if (data.id) {
        await store.dispatch(Action.updateTenantDetails(payload));
      } else {
        await store.dispatch(Action.createNewTenant(payload));
      }
      onClose(data);
    } catch (err) {
      setErrorMessage(err.message || 'Error');
    }
  };

  useEffect(() => {
    reset(getTenantCreationValues(target));
    return () => {
      setErrorMessage('');
    };
  }, [open, target]);

  return (
    <>
      <Dialog open={open}>
        <DialogTitle>{target && target?.id ? 'Edit' : 'New'}</DialogTitle>
        <DialogContent dividers>
          <FormProvider {...methods}>
            <TenantCreationDetail />
          </FormProvider>
        </DialogContent>
        <DialogActions>
          <SubmitButton handleSubmit={methods.handleSubmit(onSubmit)} isDirty={formState.isDirty} />
          <Button onClick={() => handleClose(null)} color="secondary">
            Cancel
          </Button>
        </DialogActions>
      </Dialog>
      <Snackbar open={!!errorMessage} autoHideDuration={6000} onClose={() => setErrorMessage('')}>
        <Alert onClose={() => setErrorMessage('')} severity="error">
          {errorMessage}
        </Alert>
      </Snackbar>
    </>
  );
};

export default TenantCreationDialog;
